import * as React from "react";
import { EntryJSON } from "../models/entries";
import { useSong, playSongNow, playAudio, pauseAudio } from "../state";
import { getEntryArtists } from "./SongMetadata";

interface PlaySongProps {
  entry: EntryJSON;
  dark?: boolean;
  size?: "default" | "medium" | "large";
  artists?: string[];
}

export function PlaySong({
  entry,
  size = "default",
  artists,
}: PlaySongProps): JSX.Element {
  const currentSong = useSong();
  const playing = currentSong?.id === entry.id && currentSong?.playing;

  function handlePlay(): void {
    if (!entry?.uploaded_url) {
      return;
    }

    if (playing) {
      pauseAudio();
    } else {
      playSongNow({
        name: entry.title,
        uploaded_url: entry.uploaded_url,
        entry_url: `/entry/${entry.id}`,
        entry_id: entry.id,
        artists: artists ?? getEntryArtists(entry),
      });
      setTimeout(() => playAudio(), 0);
    }
  }

  if (!entry?.uploaded_url) {
    return <span></span>;
  }

  const sizeStyles = {
    default: undefined,
    medium: { fontSize: "1.25rem" },
    large: { fontSize: "3.75rem" },
  };

  return (
    <button
      type="button"
      onClick={handlePlay}
      className="flex cursor-pointer items-center justify-center text-chips-gold transition hover:scale-105 hover:text-amber-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-chips-gold"
      aria-label={playing ? "Pause song" : "Play song"}
    >
      <i
        className={`fa ${playing ? "fa-pause" : "fa-play"}`}
        style={sizeStyles[size]}
        aria-hidden="true"
      ></i>
    </button>
  );
}
